import { Typography } from '@mui/material'
import React, { memo } from 'react'
import tw from 'twin.macro'
import { CircleTickMajor } from '@shopify/polaris-icons'
import { CollectDataStep, VehicleInsuranceCollectDataStep } from 'src/interfaces/collectData'
import { collectDataStepDataMap } from 'src/constants/collect-data/constants'
import { CollectDataStepStatus, CollectDataStepType } from 'src/constants/collect-data/enums'

interface Props {
  collectDataStep: CollectDataStep
  partIndex?: number
  className?: any
}

const StepItemComponent = ({ collectDataStep, partIndex, className }: Props) => {
  const stepData = collectDataStepDataMap[collectDataStep.type]({
    optional: Boolean(collectDataStep.optional),
  })

  let title = stepData.title
  let text = stepData.text
  const hideSubTitle = stepData?.hideSubTitle

  if (collectDataStep.type === CollectDataStepType.Form) {
    if (collectDataStep.metadata?.title) {
      title = collectDataStep.metadata?.title
    }

    if (collectDataStep.metadata?.description) {
      text = collectDataStep.metadata?.description
    }
  }

  if (
    collectDataStep.type === CollectDataStepType.SignContract &&
    collectDataStep.label !== CollectDataStepType.SignContract
  ) {
    title = `${title} - ${collectDataStep.label}`
  }

  if (collectDataStep.type === CollectDataStepType.InsuranceCoverage) {
    title = collectDataStep.metadata?.insurancePolicyProduct?.insuranceProduct?.name || title
    text =
      collectDataStep.metadata?.insurancePolicyProduct?.description ||
      collectDataStep.metadata?.insurancePolicyProduct?.insuranceProduct?.description ||
      text
  }

  if (collectDataStep.type === CollectDataStepType.VehicleInsurance) {
    const vehicleInsuranceStep = collectDataStep as VehicleInsuranceCollectDataStep

    if (vehicleInsuranceStep.metadata?.disableInsuranceUpload) {
      title = 'Vehicle Information'
      text = 'Input your vehicle details.'
    }
  }

  const completed = collectDataStep.status !== CollectDataStepStatus.Created

  if (!stepData) {
    return null
  }

  return (
    <>
      <div
        css={[
          tw`inline-flex flex-col items-start gap-2 p-4 bg-shades-0 overflow-hidden w-full`,
          className,
        ]}
      >
        <div css={tw`inline-flex items-center gap-4 flex-[0_0_auto]`}>
          {completed ? <CircleTickMajor width={20} css={tw`fill-success-500`} /> : stepData.icon}
          <div css={tw`flex flex-col gap-0.5`}>
            {!!partIndex && (
              <div
                css={[tw`rounded bg-shades-100 px-1 mb-0.5 w-fit`, completed && tw`bg-success-200`]}
              >
                <Typography
                  variant="overline"
                  fontWeight={700}
                  css={[tw`uppercase`, completed ? tw`text-success-500` : tw`text-shades-500`]}
                >{`Part ${partIndex}${completed ? ' • completed' : ''}`}</Typography>
              </div>
            )}
            {title && !hideSubTitle && <Typography variant="h4">{title}</Typography>}
            {!partIndex && <Typography css={tw`text-shades-400`}>{text}</Typography>}
          </div>
        </div>
        {!!partIndex && <Typography css={tw`text-shades-400`}>{text}</Typography>}
      </div>
    </>
  )
}

export const StepItem = memo(StepItemComponent)
